<template>
    <v-text-field
        :id="'house' + this._uid"
        autocomplete="false"
        v-model.lazy="value.search"
        :rules="[rules.required, houseCheckRule, flatCheckRule]"
        label="Город, улица, дом, квартира"
        validate-on-blur
        @change="getCadastralNumber"
    ></v-text-field>
</template>

<script>
import $ from 'jquery';
import 'suggestions-jquery';
export default {
    props: {
        model: {
            required: true
        },
        flatCheck: false,
        houseCheck: false,
        options: {
            type: Object,
            default: () => ({
                //token: 'd41d36d28500ad106eddbdc20258ec57d945f1d1',
                token: '14a86f53aaa54b7bb802c4f1b895a59ba2006b30',
                type: 'ADDRESS',
                addon: 'spinner',
                count: 5,
                minChars: 2,
                floating: true,
            }),
        },
        short: {
            default: false,
        },
    },

    data: () => ({
        element: null,
        init: false,
        value: '',
        flatTip: false,
        rules: {
            required: v => !!v || 'Обязательное поле',
        },
    }),

    computed: {
        houseCheckRule() {
            return () => !!this.value.house || 'Нужно указать номер дома';
        },
        flatCheckRule() {
            return () => (!!this.value.flat && !!this.flatCheck) || !this.flatCheck || 'Нужно указать номер квартиры';
        }
    },

    mounted() {
        this.value = this.model;
        this.element = $('#house' + this._uid);
        this.$nextTick(() => {
            this.initSuggestion();
        });
    },

    destroyed() {
        this.destroySuggestion();
    },

    watch: {
        value() {
            this.$emit('update:model', this.value);
        },
        model() {
            this.value = this.model;
        }
    },

    methods: {
        initSuggestion() {
            if (this.init) {
                return;
            }
            this.options.onSelect = suggestion => this.onSelectHouse(suggestion);
            const plugin = this.element.suggestions(this.options);
            if (this.value.search) {
                const data = {
                    query: this.value.search,
                    count: 1
                };
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.options.token
                };
                axios.post(
                    plugin.suggestions().options.serviceUrl + '/suggest/address',
                    data,
                    {headers: headers}
                ).then(response => {
                    if (response && response.data && response.data.suggestions && response.data.suggestions.length) {
                        this.onSelectHouse(response.data.suggestions[0]);
                    } else {
                        console.log(response);
                    }
                }).catch(error => {
                    console.log(error)
                });
            }

            this.init = true;
        },
        destroySuggestion() {
            this.element.suggestions().dispose();
        },
        onSelectHouse(suggestion) {
            this.value.search = suggestion.value;
            this.value.city = suggestion.data.settlement_with_type || suggestion.data.city_with_type;
            this.value.street = suggestion.data.street_with_type;
            this.value.house = suggestion.data.house;
            this.value.house_kladr = suggestion.data.house_kladr_id;
            this.value.house_fias = suggestion.data.house_fias_id;
            this.value.flat = suggestion.data.flat;
            this.value.flat_cadnum = suggestion.data.flat_cadnum;
            this.value.city_fias_id = suggestion.data.city_fias_id;
            this.value.postalCode = suggestion.data.postal_code;
            this.value.region = suggestion.data.region;
        },
        getCadastralNumber() {
            if (this.value.flat) {
                this.$emit('getCadastralNumber');
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/fields/HouseDadata.vue